module.exports = __webpack_public_path__ + "img/BE.528ba3d7.svg";